// Temporary cache for assets. to be removed when graphql is in place

const CACHE_KEY_NUMBER_OF_CARDS = 'CACHE_KEY_NUMBER_OF_CARDS' as const;
const CACHE_KEY_NUMBER_OF_TEAM_CARDS = 'CACHE_KEY_NUMBER_OF_TEAM_CARDS' as const;

const CACHE_KEY_NUMBER_OF_EMAIL_SIGNATURES = 'CACHE_KEY_NUMBER_OF_EMAIL_SIGNATURES' as const;
const CACHE_KEY_NUMBER_OF_TEAM_EMAIL_SIGNATURES = 'CACHE_KEY_NUMBER_OF_TEAM_EMAIL_SIGNATURES' as const;

const CACHE_KEY_NUMBER_OF_VIRTUAL_BACKGROUNDS = 'CACHE_KEY_NUMBER_OF_VIRTUAL_BACKGROUNDS' as const;
const CACHE_KEY_NUMBER_OF_TEAM_VIRTUAL_BACKGROUNDS = 'CACHE_KEY_NUMBER_OF_TEAM_VIRTUAL_BACKGROUNDS' as const;

const CACHE_KEY_NUMBER_OF_ACCESSORIES = 'CACHE_KEY_NUMBER_OF_ACCESSORIES' as const;
const CACHE_KEY_NUMBER_OF_TEAM_ACCESSORIES = 'CACHE_KEY_NUMBER_OF_TEAM_ACCESSORIES' as const;

type AssetKey =
  | typeof CACHE_KEY_NUMBER_OF_CARDS
  | typeof CACHE_KEY_NUMBER_OF_EMAIL_SIGNATURES
  | typeof CACHE_KEY_NUMBER_OF_VIRTUAL_BACKGROUNDS
  | typeof CACHE_KEY_NUMBER_OF_ACCESSORIES
  | typeof CACHE_KEY_NUMBER_OF_TEAM_CARDS
  | typeof CACHE_KEY_NUMBER_OF_TEAM_EMAIL_SIGNATURES
  | typeof CACHE_KEY_NUMBER_OF_TEAM_VIRTUAL_BACKGROUNDS
  | typeof CACHE_KEY_NUMBER_OF_TEAM_ACCESSORIES;

enum AssetTypes {
  VIRTUAL_BACKGROUND = 'VIRTUAL_BACKGROUND',
  CARDS = 'CARDS',
  EMAIL_SIGNATURES = 'EMAIL_SIGNATURES',
  VIRTUAL_BACKGROUNDS = 'VIRTUAL_BACKGROUNDS',
  ACCESSORIES = 'ACCESSORIES',
}

const getAssetCacheKey = (assetType: AssetTypes, isTeam: boolean): AssetKey => {
  switch (assetType + isTeam) {
    case AssetTypes.CARDS + 'true':
      return CACHE_KEY_NUMBER_OF_TEAM_CARDS;
    case AssetTypes.CARDS + 'false':
      return CACHE_KEY_NUMBER_OF_CARDS;
    case AssetTypes.EMAIL_SIGNATURES + 'true':
      return CACHE_KEY_NUMBER_OF_TEAM_EMAIL_SIGNATURES;
    case AssetTypes.EMAIL_SIGNATURES + 'false':
      return CACHE_KEY_NUMBER_OF_EMAIL_SIGNATURES;
    case AssetTypes.VIRTUAL_BACKGROUND + 'true':
      return CACHE_KEY_NUMBER_OF_TEAM_VIRTUAL_BACKGROUNDS;
    case AssetTypes.VIRTUAL_BACKGROUND + 'false':
      return CACHE_KEY_NUMBER_OF_VIRTUAL_BACKGROUNDS;
    case AssetTypes.ACCESSORIES + 'true':
      return CACHE_KEY_NUMBER_OF_TEAM_ACCESSORIES;
    case AssetTypes.ACCESSORIES + 'false':
      return CACHE_KEY_NUMBER_OF_ACCESSORIES;
    default:
      return CACHE_KEY_NUMBER_OF_CARDS;
  }
};

const cacheNumberOfAssets = (assetTypes: AssetTypes, numberOfAssets: number, isTeam = false): void => {
  const cacheKey = getAssetCacheKey(assetTypes, isTeam);
  window.localStorage.setItem(cacheKey, JSON.stringify(numberOfAssets));
};

const getNumberOfAssets = (assetTypes: AssetTypes, isTeam = false): number | null => {
  const cacheKey = getAssetCacheKey(assetTypes, isTeam);
  return JSON.parse(window.localStorage.getItem(cacheKey) || 'null');
};

const clearAllAssetsCaches = (): void => {
  window.localStorage.removeItem(CACHE_KEY_NUMBER_OF_CARDS);
  window.localStorage.removeItem(CACHE_KEY_NUMBER_OF_EMAIL_SIGNATURES);
  window.localStorage.removeItem(CACHE_KEY_NUMBER_OF_VIRTUAL_BACKGROUNDS);
  window.localStorage.removeItem(CACHE_KEY_NUMBER_OF_ACCESSORIES);
};

export { cacheNumberOfAssets, getNumberOfAssets, clearAllAssetsCaches, AssetTypes };
